import { ScrollText } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { AUDIT_PERMISSIONS } from '@/lib/permissions'

import { accountAuditLogRoute } from './routes'
import { auditHomeWidgets } from './home-widgets'

export const auditModule = defineModule({
  widgets: auditHomeWidgets,
  routes: [accountAuditLogRoute],
  sections: {
    access: [{ id: 'security', label: 'Security', order: 20 }],
  },
  navigation: {
    access: [
      {
        to: '/$entityId/audit-log',
        label: 'Audit log',
        icon: ScrollText,
        permission: AUDIT_PERMISSIONS.read,
        section: 'security',
        order: 20,
      },
    ],
  },
})
